import { render, staticRenderFns } from "./Campaign.vue?vue&type=template&id=2461f6a2"
import script from "./Campaign.vue?vue&type=script&lang=ts"
export * from "./Campaign.vue?vue&type=script&lang=ts"
import style0 from "./Campaign.vue?vue&type=style&index=0&id=2461f6a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports